export default __webpack_public_path__ + "static/media/zoomed_image_pixels.2efa4584.png";